import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disabled-trash",
  "use": "icon-disabled-trash-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-disabled-trash\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"#888\" fill-rule=\"evenodd\" d=\"M9.302 1.5H6.77L5.84 2.502H2v1.002h4.277l.928-1.002h1.653l.905 1.002H14V2.502h-3.793zm3.697 2.8h-.998l-.477 9.198H4.475L3.999 4.3h-.998l.523 10.2h8.952zM7 5.508v6.011H6V5.508zm3 6.011V5.508H9v6.011z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol